// F:\WORK\frontend_develop\multi-mir\src\components\Profile\Profile.jsx

import React, { useState } from 'react';
import './Profile.css';
import HeaderProfile from '../HeaderProfile/HeaderProfile';
import MenuNavProfile from '../MenuNavProfile/MenuNavProfile';
import WorkareaProfile from '../WorkareaProfile/WorkareaProfile';
import MyOrgsTab from '../MyOrgsTab/MyOrgsTab';
import WorkTab from '../WorkTab/WorkTab';
import Cookies from 'js-cookie'; // Для работы с куками
import { getUserData } from '../../api/userDataApi';
import { useEffect } from 'react';

const IT_TYPE_ID = 4;
const DIRECTOR_TYPE_ID = 9;
const NO_REDIRECT_TYPE_ID = 23;

const Profile = ({ activeBlok, handleSelectedBlock, fetchOrganisation }) => {
  const [selectedTab, setSelectedTab] = useState('profile');
  const [profileData, setProfileData] = useState({});

  const handleSelectedTab = (tab) => {
    setSelectedTab(tab);
  };

  useEffect(() => {
    const isMobile = window.innerWidth <= 768;

    const searchParams = new URLSearchParams(window.location.search);
    const hasNoRedirectParam = searchParams.has('no_redirect');

    getUserData().then((res) => {
      const userData = res.data;

      const userTypeId = Number(userData?.type_id);

      const canCancelRedirect = [IT_TYPE_ID, DIRECTOR_TYPE_ID, NO_REDIRECT_TYPE_ID].includes(
        userTypeId,
      );

      const shouldRedirectToCrm =
        userTypeId &&
        userTypeId !== 2 &&
        NO_REDIRECT_TYPE_ID !== userTypeId &&
        !isMobile &&
        !(canCancelRedirect && hasNoRedirectParam);

      if (shouldRedirectToCrm) {
        try {
          Cookies.set('current_organisation', userData.current_organisation, {
            expires: 7,
            domain: `.${window.APP_CONFIG?.TOKEN_DOMAIN}`,
            secure: true,
            sameSite: 'None',
          });

          const redirectUrl = new URL('https://crm.multi-mir.ru');
          // redirectUrl.searchParams.set('module', 'kanban');

          window.location.href = redirectUrl.toString();
        } catch (e) {
          console.error('Ошибка при обработке SELLER_DOMAIN:', e);
          setProfileData(userData);
        }

        return;
      }

      setProfileData(userData);
    });
  }, []);

  return (
    <>
      <div
        onClick={() => handleSelectedBlock(null)}
        className={`overlay ${activeBlok === 'profile' ? 'show' : 'hide'}`}
      ></div>

      <div
        style={{
          transform: `translateX(${activeBlok === 'profile' ? 0 : '100%'})`,
        }}
        className="profile"
      >
        <button onClick={() => handleSelectedBlock(null)} className="profile__close-btn" />
        <div className="profile_container">
          <HeaderProfile email={profileData.email} />
          <MenuNavProfile handleSelectedTab={handleSelectedTab} />

          {selectedTab === 'profile' && <WorkareaProfile profileData={profileData} />}

          {selectedTab === 'myOrganizations' && (
            <MyOrgsTab fetchOrganisation={fetchOrganisation} user_id={profileData.uuid} />
          )}

          {selectedTab === 'work' && <WorkTab />}
        </div>
      </div>
    </>
  );
};

export default Profile;
